import {
  LIST_USERS_MOVIE,
  USERS_MOVIE_FAIL,
  DELETE_USER_MOVIE,
  GET_USERS_MOVIE,
} from '../actions/types'

const initialState = {
  list: null,
  detail: null,
  delete: null,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case LIST_USERS_MOVIE:
      return {
        ...state,
        list: payload,
      }
    case USERS_MOVIE_FAIL:
      return {
        ...state,
        list: null,
      }
    case GET_USERS_MOVIE:
      return {
        ...state,
        detail: payload,
      }
    case DELETE_USER_MOVIE:
      return {
        ...state,
        delete: payload,
      }
    default:
      return state
  }
}
